// Small auth helper so Axios and fetch share the same logic
const TOKEN_KEY = 'token';
let isLoggingOut = false;

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

function clearAuthState() {
  localStorage.removeItem(TOKEN_KEY);
  // clear anything else you store (user, client, etc.)
}

function logout() {
  if (isLoggingOut) return; // avoid multiple redirects from concurrent 401s
  isLoggingOut = true;
  clearAuthState();
  // If you use React Router, you can navigate in a top-level effect.
  // The simplest approach without context here:
  window.location.href = '/login';
}

function isAuthUrl(url = '') {
  // prevent loops: don't trigger on login/refresh endpoints
  return /\/login|\/refresh|\/register/i.test(url);
}

export const auth = { getToken, setToken, logout, isAuthUrl };